import CommonModal from "@/components/ui/CommonModal";
import { notifyWarning } from "@/utils/notification";
import { Input } from "antd";
import { useCallback } from "react";
import { usePersonnelSelectorModal } from "./hooks/usePersonnelSelectorModal";
import styles from "./index.module.less";
import { ModalBody } from "./ModalBody";
import type { PersonnelItem } from "./type";

type Props = {
  open: boolean;
  onClose: () => void;
  onOk?: (personnel: PersonnelItem) => void;
};

// ==================== 主组件 ====================
export function PersonnelSelectorModal({ open, onClose, onOk }: Props) {
  const {
    searchValue,
    selectedPersonnel,
    searchedPersonnelList,
    setSelectedPersonnel,
    reset,
    handleSearch,
    eventType,
    setEventType,
    selectedDeptNo,
    setSelectedDeptNo,
    isLoading,
  } = usePersonnelSelectorModal();

  const handleClose = useCallback(() => {
    onClose();
    reset();
  }, [onClose, reset]);

  const handleOk = useCallback(() => {
    if (!selectedPersonnel) {
      notifyWarning("请先选择一个人员");
      return;
    }
    onOk?.(selectedPersonnel);
    handleClose();
  }, [selectedPersonnel, onOk, handleClose]);

  const handleSearchChange = (value: string) => {
    handleSearch(value);
  };

  return (
    <CommonModal
      title={
        <div className={styles.header}>
          <span>选择评估人</span>
          <Input
            className={styles.searchInput}
            placeholder="请输入评估人名字"
            value={searchValue}
            onChange={(e) => handleSearchChange(e.target.value)}
            allowClear
          />
        </div>
      }
      open={open}
      onCancel={handleClose}
      style={{ top: 20 }}
      width={800}
      onOk={handleOk}
    >
      <ModalBody
        eventType={eventType}
        searchedList={searchedPersonnelList}
        selectedPersonnel={selectedPersonnel}
        setSelectedPersonnel={setSelectedPersonnel}
        setEventType={setEventType}
        selectedDeptNo={selectedDeptNo}
        setSelectedDeptNo={setSelectedDeptNo}
        isLoading={isLoading}
      />
    </CommonModal>
  );
}
